import { Component, ViewEncapsulation } from '@angular/core';
import { GameWindowService } from '../../services/gameWindow.services';
import * as _ from 'underscore';
import { Utility } from '../../shared/utility/utility';
import { EmitterService } from '../../services/emitter.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-games-content',
  templateUrl: './games-content.component.html',
  styleUrls: ['./games-content.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GamesContentComponent {

  gameDetails;
  gameInfoSubs;
  gamesSubscription;
  destroy$: Subject<boolean> = new Subject()
  constructor(
    private emitterService:EmitterService,
    private gameWindowService: GameWindowService,
    private utils: Utility
  ) {
    this.emitterService.updatedActiveGameInfo$.pipe(takeUntil(this.destroy$)).subscribe(updatedActiveGameInfo => {
      if(updatedActiveGameInfo) {
        this.loadGameContent();
      }
    })
  }

  ngOnInit() {
    this.loadGameContent()
  }

  loadGameContent() {
    let allGamesData = this.gameWindowService.getAllSlotData();
    let gameInfo = this.utils.getActiveGameInfo();
    if(gameInfo){
      if(allGamesData && allGamesData.length > 0){
        let allSlotsData = _.indexBy(allGamesData, 'gameCode');
        this.gameDetails = allSlotsData[gameInfo['gameId']];
      }else{
        this.gameWindowService.getAllCasinoGames().pipe(takeUntil(this.destroy$)).subscribe(allGamesResp => {
          let allSlotsData = _.indexBy(allGamesResp, 'gameCode');
          this.gameDetails = allSlotsData[gameInfo['gameId']];
        });
      }
    }
  }

  ngOnDestroy(){
    this.destroy$.next(true)
    this.destroy$.complete()
  }
}
